import { ChangeDetectorRef, Component } from '@angular/core';
import { SpinnerService } from './shared/services/spinner.service';
import {
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router
} from '@angular/router';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(
    public spinnerService: SpinnerService,
    private cd: ChangeDetectorRef,
    private router: Router
  ) {
    this.router.events.subscribe((event: Event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.spinnerService.showSpinner$.next(true);
          break;
        }

        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          this.spinnerService.showSpinner$.next(false);
          break;
        }
        default: {
          break;
        }
      }
    });
  }

  ngAfterViewChecked() {
    this.cd.detectChanges();
  }
}
